import { Page } from '@common/ui/Page';
import routes from '@routes';
import { Outlet } from 'react-router-dom';
import { MfaBanners } from '@common/organisms/MfaBanners';
import { useFlagFixed } from '@common/utils/flags/use-flag-fixed';
import { Flags } from '@common/utils/flags/feature-flags';

export default function NewRequestLayout() {
  const { isEnabled: isEntitlementRequestFormEnabled } = useFlagFixed(Flags.ENTITLEMENT_REQUEST_FORM);
  const { isEnabled: isHideIntegrationRequestForm } = useFlagFixed(Flags.HIDE_INTEGRATION_REQUEST_FORM);

  const tabs = [{ label: routes.BundleRequest.label, to: routes.BundleRequest.path }];

  if (!isHideIntegrationRequestForm) {
    tabs.unshift({ label: routes.NewRequest.label, to: routes.NewRequest.path });
  }

  if (isEntitlementRequestFormEnabled) {
    tabs.unshift({ label: routes.ResourcesRequest.label, to: routes.ResourcesRequest.path });
  }

  return (
    <Page
      title="New Request"
      breadcrumbs={[{ label: 'My Requests', href: routes.OpenRequests.path }]}
      tabs={tabs}
      banner={<MfaBanners />}
    >
      <Outlet />
    </Page>
  );
}
